import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useGetTasksQuery } from "../../features/task/taskApi";
import TaskItem from "./TaskItem";

export default function TaskLists() {
  const { data: tasks, isLoading, isError } = useGetTasksQuery();
  const { projects, searchQuery } = useSelector((state) => state.filter);

  const filterByProject = (task) => {
    if (projects.length === 0) return true;
    return projects.includes(task.project.id);
  };

  const filterBySearch = (task) => {
    if (searchQuery === "") return true;
    return task.taskName.toLowerCase().includes(searchQuery.toLowerCase());
  };

  let taskList;
  if (isLoading) {
    taskList = <div>Loading...</div>;
  } else if (isError) {
    taskList = <div>Error!</div>;
  } else {
    taskList = tasks
      .filter(filterByProject)
      .filter(filterBySearch)
      .map((task) => <TaskItem key={task.id} task={task} />);
  }

  return (
    <>
      <div className="lg:pl-[16rem] 2xl:pl-[23rem]">
        <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
          <div className="justify-between mb-10 space-y-2 md:flex md:space-y-0">
            <Link to="/tasks/add" className="lws-addnew group">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-6 h-6 group-hover:text-indigo-500"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 4.5v15m7.5-7.5h-15"
                />
              </svg>

              <span className="group-hover:text-indigo-500">Add New</span>
            </Link>
          </div>

          <div className="lws-task-list">{taskList}</div>
        </main>
      </div>
    </>
  );
}
